<template>
	<div style="margin-top: 90px;">
		<Nav/>
    <Fix />
		<div class="container">
			<el-card class="top">
        <p v-html="pageContent"/>
			</el-card>
		</div>
		<Footer class="top"/>
	</div>
</template>

<script>
import Nav from './components/Nav.vue'
import Footer from './components/Footer.vue'
import { getPageById } from '@/api/index.js'
import Fix from "@/views/front/components/Fixed.vue";

export default {
    name: 'Page',
    components: {Fix, Nav, Footer },

    data() {
        return {
          pageContent: undefined
        };
    },

    mounted() {
        this.fetchData();
    },

    watch: {
        // 导航切换图文页时（同一路由仅 id 变化）重新拉取内容
        '$route.params.id'() {
            this.fetchData();
        }
    },

    methods: {
      async fetchData() {
        try {
          const response = await getPageById(this.$route.params.id);
          if (response && response.data) {
            this.pageContent = response.data.content;
            if (response.data.pageName) {
              document.title = `洲远 - ${response.data.pageName}`;
            }
          }
        } catch (error) {
          console.error('获取图文页失败: ' + error);
        }
      }
    }
};
</script>

<style lang="scss" scoped>

.container {
    flex: 1; // Allow the container to grow and fill available space

  p {
    font-size: 16px;
    color: #666;
    margin-bottom: 40px;
  }

  @media (max-width: 768px) {
    ::v-deep img {
      max-width: 100% !important;
    }

    ::v-deep table {
      display: block;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }

    ::v-deep iframe,
    ::v-deep video,
    ::v-deep object {
      max-width: 100% !important;
      height: auto !important;
    }
  }

  // 桌面端
  @media (min-width: 769px) {
    ::v-deep img {
      max-width: 100% !important;
    }
  }
}
</style>
